import { Card } from '@cmsgov/ds-medicare-gov'
import { Button } from 'components/Button/Button'
import { MyInternalLink } from 'components/MyLink'
import { useTranslation } from 'react-i18next'
import { buildAbsoluteMedicareMyUrl } from 'utils/urls/buildAbsoluteMedicareMyUrl'

type MsaDisclaimerProps = {
  onAccept: () => void
}
export const MsaDisclaimer = ({ onAccept }: MsaDisclaimerProps) => {
  const { t } = useTranslation('msa')

  const paragraphs = t('disclaimer.paragraphs', {
    returnObjects: true
  }) as string[]
  const bullets = t('disclaimer.bullets', { returnObjects: true }) as string[]

  const handleAccept = () => {
    // TODO: add fireEvent for relevant tracking
    // Note: could implement "decline" the same way, a nav programmatically
    onAccept()
  }

  return (
    <>
      <div>
        {paragraphs.map((content) => (
          <p className='ds-u-measure--wide ds-text-body--md'>{content}</p>
        ))}
        <ul className='ds-c-list'>
          {bullets.map((content) => (
            <li className='ds-u-measure--wide'>{content}</li>
          ))}
        </ul>
      </div>
      <Card className="ds-u-display--inline-block ds-u-padding--3 ds-u-margin-top--2">
        <h2 className="ds-text-heading--md ds-h5">
          {t('disclaimer.wcmsaHeading')}
        </h2>
        <address>
          BCRC-NGHP
          <br />
          P.O. Box 138899
          <br />
          Oklahoma City, OK 73113-8899
        </address>
        <p>
          1-855-798-2627
          <br />
          TTY: 1-855-797-2627
        </p>
      </Card>
      <div className="ds-u-margin-top--5">
        <Button
          className="ds-c-button ds-c-button--solid ds-c-button--alternate"
          onClick={handleAccept}
          siteActivityProps={{
            core: {
              component: 'Medicare Set Aside',
              elementId: 'msa_acceptdisclosure_click',
              coreClickData: {
                linkText: t('disclaimer.acceptButton'),
                linkUrl: buildAbsoluteMedicareMyUrl('/claims/msa')
              }
            }
          }}
        >
          {t('disclaimer.acceptButton')}
        </Button>
        <MyInternalLink
          to="/claims"
          className="ds-c-button ds-u-margin-left--2"
          siteActivityProps={{
            core: {
              component: 'Medicare Set Aside',
              elementId: 'msa_declinedisclosure_click',
              coreClickData: {
                linkText: t('disclaimer.declineButton'),
                linkUrl: buildAbsoluteMedicareMyUrl('/claims/msa')
              }
            }
          }}
        >
          {t('disclaimer.declineButton')}
        </MyInternalLink>
      </div>
    </>
  )
}
